import storage from '@/utils/storage';

// 一些默认值
// 投保时候身份证上传录入信息
const insuredIdCardUploadInfo = {
    holder: {
        IF: {
            category: 'IF',
            fileName: '',
            fileType: '',
            file: '',
            upload: ''
        },
        IB: {
            category: 'IB',
            fileName: '',
            fileType: '',
            file: '',
            upload: ''
        }
    },
    // 被保人 可能存在多个
    insurers: [
        {

            IF: {
                category: 'IF',
                fileName: '',
                fileType: '',
                file: '',
                upload: ''
            },
            IB: {
                category: 'IB',
                fileName: '',
                fileType: '',
                file: '',
                upload: ''
            }
        },
    ]
};

// 产品自身属性信息
const productInfo = {
    productCode: '', // 产品id
    productName: '', // 产品id
    allPdfFile: '', // 所有的 pdf 文件
    insuranceScope: [ // 产品保障范围
        // { name: '被保人年龄', value: '' },
        // { name: '被保人性别', value: '' },
        // { name: '保障金额', value: '' },
        // { name: '保险期限', value: '' },
        // { name: '缴费期间', value: '' },
        // { name: '附加险', value: '' },
    ],
};

// 保单录入信息
const insureInfo = {
    insuredInfo: [], // 被保人信息模板及数据
    holderInfo: [], // 投保人信息
    confirmSubmitId: '', // 信息确认页 confirmSubmitId id
    price: '',
    totalPrice: '',
    timeLimit : [],
    bankInfo : [],
};


// 美泰保重疾试算
const information = {
    chargeYear:'', // 缴费期间
    amount:'' +'0000', // 保障金额
    productCode:'', // 产品id
    insured:[{
        birthDate:'',//被保人出生日期
        sex:'' // 被保人性别
    }]
};

// 登录页的一些信息
const login = {
    phone: '', // 用户手机号
};


const OrderProcessUploadInfo = {};


export const state = {
    // 投保时候身份证上传录入信息
    insuredIdCardUploadInfo: storage.get('insuredIdCardUploadInfo') ? JSON.parse(storage.get('insuredIdCardUploadInfo')) : insuredIdCardUploadInfo,
    productInfo: storage.get('productInfo') ? JSON.parse(storage.get('productInfo')) : productInfo,
    insureInfo: storage.get('insureInfo') ? JSON.parse(storage.get('insureInfo')) : insureInfo,
    information: storage.get('information') ? JSON.parse(storage.get('information')) : information,
    login: storage.get('login') ? JSON.parse(storage.get('login')) : login,
    OrderProcessUploadInfo : storage.get('OrderProcessUploadInfo') ? JSON.parse(storage.get('OrderProcessUploadInfo')) : OrderProcessUploadInfo
};



// WEBPACK FOOTER //
// ./src/vuex/state.js